var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "annieBox" },
    [
      _c("div", { staticClass: "header", attrs: { id: "header" } }, [
        _c("i", { on: { click: _vm.goHome } }),
        _vm._v(" "),
        _c("div", { staticClass: "mainBox1 clearfix" }, [
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.$t("language")) + "\n        "),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.changeLangBox,
                      expression: "changeLangBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                _vm._l(_vm.langList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "chooseLangUlli",
                      on: {
                        click: function($event) {
                          _vm.setLanguage(item.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.name) + "\n          "
                      )
                    ]
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "settingBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.setting()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.name ? _vm.name : _vm.names) +
                  "\n        "
              ),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.settingBoxVis,
                      expression: "settingBoxVis"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                [
                  _c("li", { on: { click: _vm.goIndex } }, [
                    _vm._v(_vm._s(_vm.$t("myHome")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.race } }, [
                    _vm._v(_vm._s(_vm.$t("myPageTitle")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logOut } }, [
                    _vm._v(_vm._s(_vm.$t("setting_2")))
                  ])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mainBox clearfix",
          attrs: { id: "mainBox" },
          on: { click: _vm.clickBox }
        },
        [
          _c("div", { staticClass: "conBox" }, [
            _c("div", { staticClass: "left-box" }, [
              _c("div", { staticClass: "tips" }, [
                _vm._v(_vm._s(_vm.courseFilter(_vm.gameId)))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                [
                  _c("li", { staticClass: "clearfix" }, [
                    _c("span", { staticClass: "fl" }, [
                      _vm._v(_vm._s(_vm.$t("competition_txt1")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fl" }, [
                      _vm._v(_vm._s(_vm.$t("competition_txt22")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fl countrys" }, [
                      _vm._v(_vm._s(_vm.$t("competition_txt8")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fl" }, [
                      _vm._v(_vm._s(_vm.$t("competition_txt3")))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.alldata, function(item, index) {
                    return _c("li", { key: index, staticClass: "clearfix" }, [
                      _c("span", { staticClass: "fl number1" }, [
                        _vm._v(_vm._s(item.rank))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fl" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.firstName) +
                            "  " +
                            _vm._s(item.schoolCnName) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fl countrys" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.lan == "zh" ? "中国" : "China") +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "fl" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.$t("allStars"),
                                placement: "top-end"
                              }
                            },
                            [_c("i", { staticClass: "Allstar" })]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "allScore" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  item.totalScore ? item.totalScore : "/"
                                ) +
                                "\n              "
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.listQuery.page,
                      "page-size": _vm.listQuery.size,
                      "page-count": _vm.listQuery.count,
                      layout: " prev, pager, next"
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function($event) {
                        _vm.$set(_vm.listQuery, "page", $event)
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right-box" }, [
              _c(
                "div",
                { staticClass: "gameImg", class: { gameImgEn: _vm.flagSte } },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-carousel",
                        { attrs: { trigger: "click", height: "160px" } },
                        [
                          _vm.currentGameLevel == 0
                            ? _c("el-carousel-item", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.$t("notice_lang4"))
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentGameLevel == 10
                            ? _c("el-carousel-item", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("mars_bulletin") + _vm.ysTime
                                    )
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentGameLevel == 20
                            ? _c("el-carousel-item", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("jupiter_bulletin") + _vm.ysTime
                                    )
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentGameLevel == 30
                            ? _c("el-carousel-item", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("saturn_bulletin") + _vm.ysTime
                                    )
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentGameLevel == 40
                            ? _c("el-carousel-item", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("level5_bulletin") + _vm.ysTime
                                    )
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentGameLevel == 50
                            ? _c("el-carousel-item", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("level6_bulletin") + _vm.ysTime
                                    )
                                  }
                                })
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "allMsg allMsg1" },
                [
                  _c("div", { staticClass: "myAchievement" }, [
                    _vm._v(_vm._s(_vm.$t("MyScore")))
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "ul" }, [
                    _c("li", { staticClass: "clearfix" }, [
                      _c("span", { staticClass: "fl" }, [
                        _vm._v(_vm._s(_vm.$t("schoolName")))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fr" }, [
                        _vm._v(_vm._s(_vm.schoolName ? _vm.schoolName : "/"))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("span", { staticClass: "fl" }, [
                        _vm._v(_vm._s(_vm.$t("myStars")))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fr" }, [
                        _vm._v(_vm._s(_vm.myScore ? _vm.myScore : "/"))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.startGameShow,
                          expression: "startGameShow"
                        }
                      ],
                      staticClass: "startGame",
                      class: { fz: _vm.flagSte },
                      on: { click: _vm.goCode }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("competition_button")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: _vm.getButtonTipsTxt(),
                        placement: "top-end"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.startGameShow,
                              expression: "!startGameShow"
                            }
                          ],
                          staticClass: "startGame startGame11",
                          class: { fz: _vm.flagSte }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("competition_button")) +
                              "\n            "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "600px" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("broswer1")))]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer"
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      "https://istatic.codingolympics.cn/soft/ChromeStandaloneSetup.exe"
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("broswer2")) + "\n      ")]
              ),
              _vm._v("\n        \n      "),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      "https://istatic.codingolympics.cn/soft/ChromeStandaloneSetup64.exe"
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("broswer3")) + "\n      ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("LeapPopup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.maskBox,
            expression: "maskBox"
          }
        ],
        attrs: {
          title: _vm.$t("timeout01"),
          content: _vm.$t("timeout02"),
          cancelButtonTxt: _vm.$t("timeout04"),
          okButtonTxt: _vm.$t("timeout03"),
          isConfirm: false
        },
        on: { onOK: _vm.logOut }
      }),
      _vm._v(" "),
      _c("LeapPopup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showFirstEnter,
            expression: "showFirstEnter"
          }
        ],
        attrs: {
          title: _vm.$t("week_game_tips_info_txt"),
          content: _vm.$t("week_game_tips_info"),
          cancelButtonTxt: _vm.$t("week_warning_btn_not_start"),
          okButtonTxt: _vm.$t("week_warning_btn_start"),
          isConfirm: true
        },
        on: { onConfirm: _vm.monthConfirmOK, onCancel: _vm.monthConfirmCancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f07f68a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f07f68a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/monthly.vue
// module id = null
// module chunks = 